import * as React from "react";
import { Modal, Spin } from "antd";
import { EditDistributorForm } from "./EditDistributorForm";

export class EditModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            data: [],
            recordDetails: {},
            isLoading: false, // Fixme this should be true
            closable: true,
        };
    }

    componentDidMount() {
        if (this.props.refx) {
            this.props.refx(this);
        }
    }

    handleOk = (e) => {
        this.setState({
            visible: false,
        });
    };

    handleCancel = (e) => {
        this.hide();
    };

    show() {
        this.setState({
            visible: true,
        });
    }

    hide() {
        this.setState({
            visible: false,
        });
        this.props.onClose();
    }


    render() {
        return (
            // <StyleBox>
            <Modal
                width="600px"
                closable={this.state.closable}
                open={this.state.visible}
                title="Edit Distributor"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                footer={null}
                destroyOnClose={true}
            >
                {this.state.isLoading ? (
                    <div style={{ justifyContent: "center" }}>
                        <Spin />
                    </div>
                ) : (

                    <EditDistributorForm
                        authToken={this.props.authToken}
                        loginUserData={this.props.loginUserData}
                        data={this.props.editDistributedData}
                        onClose={this.hide}
                        onSubmit={this.props.editSubmit}
                        handleCancel={this.handleCancel}
                    />

                )}
            </Modal>
        );
    }
}
